import { render } from "./ForkliftFilters.vue?vue&type=template&id=f980cb1e"
import script from "./ForkliftFilters.vue?vue&type=script&lang=js"
export * from "./ForkliftFilters.vue?vue&type=script&lang=js"

import "./ForkliftFilters.vue?vue&type=style&index=0&id=f980cb1e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__